import { useMemo } from 'react';

export default function useTextMaxLength(
  text: string,
  fontSize: number,
  maxChars: number,
  enableTooltip?: boolean
) {
  const fontChWide = useMemo(() => {
    return fontSize / 2;
  }, [fontSize]);

  const needTooltip = useMemo(() => {
    return text.length * fontChWide > maxChars * fontChWide;
  }, [text, fontChWide, maxChars]);

  const newText = useMemo(() => {
    if (needTooltip && enableTooltip) {
      return `${text.slice(0, maxChars - 3).trim()}...`;
    }
    return text;
  }, [needTooltip, text, maxChars, enableTooltip]);

  return { needTooltip, newText };
}
